import Modal from 'react-rainbow-components/components/Modal';
import styled from 'styled-components';
import { GREY_200, GREY_500 } from '../../../constants';

export const StyledModal = styled(Modal)`
    width: 80%;
    height: 75%;
    max-width: 1400px;
    max-height: 900px;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    justify-content: space-between;
`;

export const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const TitleDescription = styled.p`
    font-size: 14px;
    color: ${GREY_500};
    font-weight: 500;
    margin-bottom: 4px;
`;

export const VersionHint = styled.p`
    font-size: 13px;
    color: ${GREY_500};
    margin-top: 0;
`;

export const DiffContainer = styled.div`
    border: 2px solid ${GREY_200};
    border-radius: 10px;
    height: 100%;
    overflow: auto;
`;

export const ModalFooter = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
    padding: 1rem;
`;
